type ToastType = 'success' | 'error' | 'warning' | 'info'

interface Toast {
  id: number
  type: ToastType
  message: string
  duration: number
}

export const useToast = () => {
  const toastList = useState<Toast[]>('toastList', () => [])

  const remove = (id: number) => {
    toastList.value = toastList.value.filter((toast) => toast.id !== id)
  }

  const add = (message: string, type: ToastType = 'success', duration = 3200) => {
    const id = Date.now()

    toastList.value.push({
      id,
      message,
      type,
      duration,
    })

    setTimeout(() => {
      remove(id)
    }, duration)
  }

  const success = (msg: string) => {
    add(msg, 'success')
  }

  const error = (msg: string) => {
    add(msg, 'error')
  }

  const warning = (msg: string) => {
    add(msg, 'warning')
  }

  const info = (msg: string) => {
    add(msg, 'info')
  }

  return {
    toast: {
      success,
      error,
      warning,
      info,
    },
    toastList: readonly(toastList),
    remove,
  }
}
